import { PageRoute } from "..";
import { ThemeProvider } from "@emotion/react";
import { FC, useState } from "react";
import { useSelector } from "react-redux";
import { Route, Switch } from "react-router-dom";

import Redirect from "components/Redirect";
import { selectIsAdmin } from "store/entities/agents";
import { selectIsCompanyNameSet } from "store/entities/license";
import {
  selectSkipStandaloneAppTutorialForwardingStep,
  selectSkipStandaloneAppTutorialInviteTeammatesStep,
} from "store/views/welcome-tutorial";
import { legacyTheme } from "themes/legacyTheme";

import { CompanyNameContext, WelcomeTutorialRoutes } from "./helpers";
import { FinishStandaloneAppTutorial } from "./steps/FinishStandaloneAppTutorial";
import { InviteTeammates } from "./steps/InviteTeammates";
import { Mailbox } from "./steps/Mailbox";
import { Forwarding } from "./steps/forwarding/Forwarding";

export const StandaloneAppTutorial: FC = () => {
  const isAdmin = useSelector(selectIsAdmin);
  const skipForwardingStep = useSelector(selectSkipStandaloneAppTutorialForwardingStep);
  const skipInviteTeammatesStep = useSelector(selectSkipStandaloneAppTutorialInviteTeammatesStep);
  const isCompanyNameSet = useSelector(selectIsCompanyNameSet);

  const [wasCompanyNameSet] = useState(isCompanyNameSet);

  return (
    <ThemeProvider theme={legacyTheme}>
      <CompanyNameContext.Provider value={wasCompanyNameSet}>
        <Switch>
          {isAdmin && !wasCompanyNameSet && (
            <PageRoute
              exact
              path={WelcomeTutorialRoutes.MAILBOX}
              documentTitle="Define your display name"
              component={Mailbox}
            />
          )}
          {!skipInviteTeammatesStep && (
            <PageRoute
              exact
              path={WelcomeTutorialRoutes.INVITE}
              documentTitle="Invite your team"
              component={InviteTeammates}
            />
          )}
          {!skipForwardingStep && (
            <PageRoute
              exact
              path={WelcomeTutorialRoutes.FORWARDING}
              documentTitle="Get your emails into HelpDesk"
              component={Forwarding}
            />
          )}
          {!isAdmin && <Redirect exact from={WelcomeTutorialRoutes.MAILBOX} to={WelcomeTutorialRoutes.FORWARDING} />}
          {skipInviteTeammatesStep && (
            <Redirect exact from={WelcomeTutorialRoutes.INVITE} to={WelcomeTutorialRoutes.FORWARDING} />
          )}
          {skipForwardingStep && (
            <Redirect exact from={WelcomeTutorialRoutes.FORWARDING} to={WelcomeTutorialRoutes.FINISH} />
          )}
          <Route exact path={WelcomeTutorialRoutes.FINISH} component={FinishStandaloneAppTutorial} />
          <Redirect to={wasCompanyNameSet ? WelcomeTutorialRoutes.INVITE : WelcomeTutorialRoutes.MAILBOX} />
        </Switch>
      </CompanyNameContext.Provider>
    </ThemeProvider>
  );
};
